const getProductName = (combinedName?: any) => {
  let splitted: any = combinedName?.split("-")
  if (splitted?.length === 1) {
    return [undefined, splitted[0]]
  }
  return splitted;
}

export default getProductName